/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import classNames from 'classnames';
import './SelectBox.scss';

import SelectIcon from 'assets/icons/icon-dropdown.svg';
import InfoIcon from 'assets/icons/icon-info.svg';

class SimpleSelectBox extends Component {
  state = {
    showList: false,
    selected: this.props.defaultValue,
    inputValue: this.props.defaultValue,
    selectedValue: true,
    isFocus: false,
    isTouched: this.props.isSubmitClicked,
  };

  handleSelect = (name, value) => {
    this.setState({
      selected: value,
      showList: false,
      inputValue: value,
    });
    this.props.onSelect(name, value);
  };

  handleInputChange = (e) => {
    this.setState({
      inputValue: e.target.value,
      showList: true,
      selectedValue: false,
    });
  };

  handleInputBlur = (notFound) => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      inputValue: notFound ? this.props.defaultValue : this.state.inputValue,
      selectedValue: true,
      isFocus: false,
      isTouched: true,
    });
  };

  render() {
    const {
      label, dataList, intl, placeholder, name, withInfo, onWithInfoClick, isSearchInputDisabled,
      isValid, errorMessage, isSubmitClicked, isDisabled,
    } = this.props;
    const {
      showList, inputValue, selectedValue, isFocus, isTouched,
    } = this.state;
    const filteredList = dataList.filter(item => selectedValue || _.toLower(item).includes(_.toLower(inputValue)));
    const selectBoxClass = classNames({
      'select-box--focused': isFocus,
    });

    return (
      <>
        <div className={`select-box ${selectBoxClass}`}>
          {label && (
            <span className="select-box__label">
              {label}
              {withInfo && <img src={InfoIcon} alt="More info" onClick={() => onWithInfoClick(name)} />}
            </span>
          )}
          <div
            className="select-box__current"
            tabIndex={1}
            onClick={() => {
              // eslint-disable-next-line react/no-access-state-in-setstate
              this.setState({ showList: !this.state.showList });
            }}
            onBlur={() => {
              this.setState({ showList: false });
            }}
          >
            <div className="select-box__value">
              <input
                className="select-box__input"
                onChange={() => {}}
                type="radio"
                checked="checked"
                name={name}
              />
              <input
                className={`select-box__input-text ${!isValid && (isTouched || isSubmitClicked) ? 'select-box__input-text--invalid' : ''}`}
                disabled={isSearchInputDisabled || isDisabled}
                type="text"
                value={inputValue}
                placeholder={placeholder}
                autoComplete="off"
                onChange={this.handleInputChange}
                onBlur={() => this.handleInputBlur(_.isEmpty(filteredList))}
                onFocus={() => this.setState({ isFocus: true })}
              />
            </div>
            <img className={`select-box__icon ${showList && !isDisabled ? 'select-box__icon--active' : ''}`} src={SelectIcon} alt="Arrow Icon" />
          </div>
          <ul className={`select-box__list ${showList && !isDisabled ? 'select-box__list--active' : ''}`}>
            {!_.isEmpty(filteredList)
              ? filteredList.map(value => (
                <li
                  key={value}
                  onMouseDown={() => this.handleSelect(name, value)}
                >
                  <label
                    className={`select-box__option ${value === this.state.selected ? 'select-box__option--active' : ''}`}
                    htmlFor={value}
                  >
                    {value}
                  </label>
                </li>
              ))
              : (
                <li>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label
                    className="select-box__option select-box__option--disabled"
                  >
                    {intl.formatMessage({ id: 'selectBox.notFound' })}
                  </label>
                </li>
              )
              }
          </ul>

          {!isValid && (isTouched || isSubmitClicked) && errorMessage && (
            <span className="notification notification--error">
              {errorMessage[0]}
            </span>
          )
          }
        </div>
      </>
    );
  }
}

SimpleSelectBox.propTypes = {
  // select list
  dataList: PropTypes.arrayOf(PropTypes.string),
  // title of select
  label: PropTypes.string,
  // on select item
  onSelect: PropTypes.func,
  /** Placeholder */
  placeholder: PropTypes.string,
  /** input name */
  name: PropTypes.string,
  /** with information icon */
  withInfo: PropTypes.bool,
  /** with info event */
  onWithInfoClick: PropTypes.func,
  /** isSearchInputDisabled */
  isSearchInputDisabled: PropTypes.bool,
  /** is select valid */
  isValid: PropTypes.bool,

  /** is disabled */
  isDisabled: PropTypes.bool,
  /** error message */
  errorMessage: PropTypes.arrayOf(PropTypes.string),
};

SimpleSelectBox.defaultProps = {
  dataList: [],
  label: '',
  onSelect: () => {},
  placeholder: '',
  name: 'nw',
  withInfo: false,
  onWithInfoClick: () => {},
  isSearchInputDisabled: true,
  isValid: true,
  errorMessage: null,
  isDisabled: false,
};

export default injectIntl(SimpleSelectBox);
